module.exports = __webpack_public_path__ + "img/hero-bg-doctor.12221dea.jpg";